import { Link } from "react-router-dom";

const channelLinks = [
  { label: "电视剧", path: "/category/电视剧" },
  { label: "综艺", path: "/category/综艺" },
  { label: "电影", path: "/category/电影" },
  { label: "动漫", path: "/category/动漫" },
  { label: "纪录片", path: "/category/纪录片" },
];

const friendLinks = [
  { label: "娱乐资讯", path: "/news" },
  { label: "关于我们", path: "/about" },
  { label: "搜索中心", path: "/search" },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-900 text-primary-100">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 px-4 py-12 md:grid-cols-4 md:px-6">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-primary-700">
              <i className="ri-mickey-fill text-lg" />
            </span>
            <span className="font-heading text-xl font-extrabold text-background-50">芒果tv</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-primary-100/90">
            芒果tv 是一个集合电视剧、综艺、电影、动漫、纪录片等多频道视频展示与娱乐资讯浏览的综合性影视门户，致力于为观众提供清晰、丰富、易用的观影导航体验。
          </p>
          <p className="mt-4 text-xs text-primary-200/80">
            本站为演示型影视门户，页面内作品、演员、评分与资讯均为虚构或中性示例数据，仅用于产品预览。
          </p>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold text-background-50">频道导航</h4>
          <ul className="mt-4 space-y-2 text-sm">
            {channelLinks.map((l) => (
              <li key={l.path}>
                <Link to={l.path} className="text-primary-100/90 hover:text-background-50 cursor-pointer">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold text-background-50">友情链接</h4>
          <ul className="mt-4 space-y-2 text-sm">
            {friendLinks.map((l) => (
              <li key={l.path}>
                <Link to={l.path} className="text-primary-100/90 hover:text-background-50 cursor-pointer">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-800">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-4 py-5 text-xs text-primary-200/80 md:flex-row md:items-center md:justify-between md:px-6">
          <p>© 2025 芒果tv 影视平台 · 演示项目，仅供学习参考</p>
          <p>内容均为示例数据，不涉及真实影视作品与版权内容</p>
        </div>
      </div>
    </footer>
  );
}